module.exports = __webpack_public_path__ + "img/Jonathan_Wang.39961e57.png";